import { axios } from '@/services/axios';

const getTriggerEvents = async (scope) => {
    const res = await axios.get('/trigger/events/', {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default getTriggerEvents;
